import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@leadsnavi/ui-kit';
import BasePagination, { PaginationProps } from '@/common/base/pagination';
import { getNextSortOrder, HeadSortIcon } from '@/common/base/head-sort-icon';
import { IApiTransactionRecordListVO, IApiTransactionRecordVO } from '@/services/swagger/customs/models';
import { useState } from 'react';
import { RecordDetailModal } from './record-detail';
import { SortOrder } from '@/common/base/head-sort-icon/types';
import { Ellipse } from '@/common/base/ellipse';
import { TextTranslate } from '@/components/translate-icon';

type RecordListProps = {
  data: IApiTransactionRecordListVO | void;
  sortBy?: string;
  order?: SortOrder;
  onSortChange?: (params: { sortBy: string; order: SortOrder }) => void;
} & Pick<PaginationProps, 'onPageChange'>;
const transValue = <_, T>(data: T): T | '-' => {
  if (data === '未公开') {
    return '-';
  }
  return data;
};

export const RecordList: React.FC<RecordListProps> = props => {
  const { data, onPageChange, sortBy, order, onSortChange } = props;

  const [recordDetailVisible, setRecordDetailVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<IApiTransactionRecordVO | void>();
  const currentPage = (data?.from || 0) + 1;

  return (
    <div>
      <Table className=" table-fixed">
        <TableHeader>
          <TableRow className="bg-[#FAFAFA] border-none">
            <TableHead
              className="w-[120px] py-2 whitespace-normal word-break-break-all  cursor-pointer"
              onClick={() => {
                if (onSortChange) {
                  onSortChange({ sortBy: 'shpmtDate', order: getNextSortOrder(order) });
                }
              }}
            >
              <div className="inline-flex gap-1 items-center">
                Trading Date
                <HeadSortIcon sortOrder={sortBy === 'shpmtDate' ? order : undefined} />
              </div>
            </TableHead>
            {/* 换行 */}
            <TableHead className="py-2  whitespace-normal word-break-break-all ">Product Description</TableHead>
            {/* <TableHead className="w-1/9 py-2">HSCode</TableHead> */}
            <TableHead className="w-1/9 py-2">Buyer</TableHead>
            <TableHead className="w-1/9 py-2">Buyer Areas</TableHead>
            <TableHead className="w-1/9 py-2 whitespace-normal word-break-break-all">Transaction Amount($)</TableHead>
            {/* <TableHead className="w-1/9 py-2 whitespace-normal word-break-break-all">Transaction weight(kg)</TableHead> */}
            <TableHead className="w-[100px] py-2">Operate</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data?.transactionRecords.map(record => (
            <TableRow key={record.recordId}>
              <TableCell>{transValue(record.shpmtDate)}</TableCell>
              <TableCell>
                <TextTranslate text={transValue(record.goodsShpd)} renderText={text => <Ellipse text={text} />} />
              </TableCell>
              {/* <TableCell>
                <div className="overflow-hidden text-ellipsis whitespace-nowrap">{record.hsCode}</div>
              </TableCell> */}
              <TableCell>
                <Ellipse text={transValue(record.showCompanyName)} />
              </TableCell>
              <TableCell>
                <Ellipse text={transValue(record.country)} />
              </TableCell>
              <TableCell>
                <Ellipse text={transValue(record.valueOfGoodsUSD)} />
              </TableCell>
              {/* <TableCell>
                <div className="overflow-hidden text-ellipsis whitespace-nowrap">{record.weightKg}</div>
              </TableCell> */}
              <TableCell>
                <span
                  className="text-blue-600 hover:underline flex items-center gap-1 cursor-pointer"
                  onClick={() => {
                    setCurrentRecord(record);
                    setRecordDetailVisible(true);
                  }}
                >
                  View
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="flex justify-center mt-4">
        <BasePagination
          total={data?.total || 0}
          page={currentPage}
          pageSize={data?.size || 0}
          onPageChange={onPageChange}
        />
      </div>
      <RecordDetailModal
        recordId={currentRecord?.recordId}
        sourceType={currentRecord?.sourceType}
        visible={recordDetailVisible}
        onClose={() => {
          setRecordDetailVisible(false);
        }}
      />
    </div>
  );
};
